import React from "react";
import Multistep from "react-multistep";
import PersonalInfos from "./1PersonalInfos";
import Abonnement from "./2Abonnment";
import PaymentMethods from "./3PaymentMethods";
import { Steps , Panel  } from 'rsuite';
import '../../css/StepsRegistration.css'
import {Button} from "react-bootstrap";



export default function AfterRegistartion(){
    const [step, setStep] = React.useState(0);
    const onChange = nextStep => {
        setStep(nextStep < 0 ? 0 : nextStep > 3 ? 3 : nextStep);
    };

    const onNext = () => onChange(step + 1);
    const onPrevious = () => onChange(step - 1);

    return (
        <div>
            <Steps current={step}>
                <Steps.Item title="Finished" description="Description" />
                <Steps.Item title="In Progress" description="Description" />
                <Steps.Item title="Waiting" description="Description" />
                <Steps.Item title="Waiting" description="Description" />
            </Steps>
            <hr />
            <Panel header={`Step: ${step + 1}`}>
                <div>Random Content</div>
            </Panel>
            <hr />
            <div className="d-flex justify-content-end">
                <Button variant="light light" onClick={onPrevious} disabled={step === 0}>Previous</Button>
                <Button variant="dark light ml-3" onClick={onNext} disabled={step === 3}>Next</Button>
            </div>

            {/*<ButtonGroup>*/}
            {/*    <Button onClick={onPrevious} disabled={step === 0}>*/}
            {/*        Previous*/}
            {/*    </Button>*/}
            {/*    <Button onClick={onNext} disabled={step === 3}>*/}
            {/*        Next*/}
            {/*    </Button>*/}
            {/*</ButtonGroup>*/}
        </div>
    );
}
